import config from 'js/app/config';

const getProviderMarkupData = (pageContent: $TSFixMe) => {
  return {
    '@type': 'CollegeOrUniversity',
    '@id': `https://www.coursera.org/${pageContent?.partnerInformation?.partnerSlug}#institution`,
    name: pageContent?.partnerInformation?.partnerName,
  };
};

const getBreadcrumbListMarkupData = (pageContent: $TSFixMe, pageInfo: $TSFixMe) => {
  return {
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        item: {
          name: 'Online Degrees',
          '@id': `${config.url.base}degrees`,
        },
      },
      {
        '@type': 'ListItem',
        position: 2,
        item: {
          name: `${pageContent?.programCategory} Degrees`,
          '@id': `https://www.coursera.org/degrees/${pageContent?.programCategoryId}`,
        },
      },
      {
        '@type': 'ListItem',
        position: 3,
        item: {
          name: pageContent?.programName,
          '@id': `https://www.coursera.org/degrees/${pageContent?.slug}`,
        },
      },
      {
        '@type': 'ListItem',
        position: 4,
        item: {
          name: pageInfo?.pageName,
          '@id': `https://www.coursera.org${pageInfo?.pathName}`,
        },
      },
    ],
  };
};

const getCredentialCategoryMarkupData = (pageContent: $TSFixMe) => {
  return {
    '@type': 'DefinedTerm',
    '@id': 'https://credreg.net/ctdl/terms/#MasterDegree',
    name: "Master's Degree",
    inDefinedTermSet: {
      '@type': 'DefinedTermSet',
      '@id': 'https://credreg.net/ctdl/terms/',
      name: 'Credential Transparency Description Language',
    },
  };
};

export { getBreadcrumbListMarkupData, getCredentialCategoryMarkupData, getProviderMarkupData };
